export let language = null;
export let parameters = {};

/**
 * Initialize parameters retrieving for the given type
 *
 * @param {string} type The type of parameters to fetch (ie 'WEBAPP')
 * @param {string} langCode Lang code to retrieve. Default 'nl'
 * @param {string} rootUrl Root URL of the back-end. Default ''
 */
export async function initialize (type, langCode = 'nl', rootUrl = '') {
  if (!type || typeof type !== 'string') {
    throw new Error(`type parameter should be specified: ${type} given`);
  }
  if (!langCode || !['nl', 'en', 'fr', 'de'].includes(langCode)) {
    throw new Error(`langCode parameter should be one of nl, en, fr, de: ${langCode} given`);
  }
  language = langCode;
  parameters = await fetchParameters(type, rootUrl);
};

/**
 * Retrieve parameter x from her key
 *
 * @param {string} key The specific key to search
 */
export function getParameter (key) {
  return parameters && parameters[key] ? parameters[key] : undefined;
};

/**
 * Returns the values of all parameters in the group with the given group prefix
 *
 * @param prefix The common key prefix of the group of parameters
 */
export function getParametersInGroup (prefix) {
  return Object.keys(parameters)
    .filter(key => key.startsWith(prefix))
    .sort()
    .map(key => parameters[key]);
};

/**
 * Fetches the parameters for the given type from the backend on the given rootUrl
 *
 * @param {string} type The type of parameters to fetch (ie 'WEBAPP')
 * @param {string} rootUrl Root URL of the back-end. Default ''
 */
export async function fetchParameters (type, rootUrl = '') {
  /* eslint-disable-next-line no-undef */
  const request = await fetch(`${rootUrl}/api/parameters/${type}/${language}`)
    .catch(err => new Error(`Parameters could not be fetched: ${err.message}`));

  if (request instanceof Error) {
    return {};
  }

  const parameters = await request.json();

  if (!parameters || !parameters.length) {
    return {};
  }

  return parameters
    .filter(parameter => parameter[language] || parameter.value)
    .reduce((acc, current) => {
      acc[current.key] = current[language] || current.value;
      return acc;
    }, {});
};

export default { initialize };
